<template>
  <v-app id="inspire">
    <v-content>
      <v-container class="fill-height" fluid>
        <v-row align="center" justify="center">
          <v-col cols="12" sm="8" md="8">
            <v-card class="elevation-12">
              <v-card-title style="background-color:#006699;color:white;">
                 Painel de Configuração
              </v-card-title>
             <template>
                <v-stepper v-model="e1">
                  <v-alert v-model="alerta" type="success">
                  Empresa registrada com sucesso.
                </v-alert>
                  <v-stepper-header>

                    <v-stepper-step color="#006699" :complete="e1 > 1" step="1"> Passo 1 - Dados da Empresa</v-stepper-step>

                    <v-divider></v-divider>

                    <v-stepper-step color="#006699" :complete="e1 > 2" step="2">Passo 2 - Tipo de Negócio</v-stepper-step>

                    <v-divider></v-divider>

                    <v-stepper-step color="#006699" :complete="e1 > 3" step="3">Passo 3 - Tipo de Regime</v-stepper-step>

                    <v-divider></v-divider>

                    <v-stepper-step color="#006699" :complete="e1 > 4" step="4">Passo 4 - Dados Predifinidos</v-stepper-step>

                  </v-stepper-header>

                  <v-stepper-items>
                    <v-stepper-content step="1">
                      <v-form
                    ref="form1"
                    v-model="valid1"
                    lazy-validation
                    >
                      <v-card
                        class="mb-12"
                        color="white"
                        style="background-color:#ccc;"
                        height="500px"
                      >
                        <v-card-title>Informações da Empresa</v-card-title>
                    
                        <v-card-text>
                          <v-row>
                              <v-col md="6">
                                 <span>Nome da Empresa*</span>
                                 <v-text-field v-model="editedItem.empresa" :rules="ruleRequired" label="Ex: SoftLine-Angola, Lda" ></v-text-field>
                              </v-col>
                              <v-col md="6">
                                 <span>Nº de contribuinte*</span>
                                 <v-text-field v-model="editedItem.contribuinte" :rules="ruleRequired" label="Ex: 001292837" ></v-text-field>
                              </v-col>
                          </v-row>
                          <v-row>
                              <v-col>
                                 <span>Seu Nome</span>
                                 <v-text-field v-model="editedItem.nome" :rules="ruleRequired" label="Nome do usuário principal"></v-text-field>
                              </v-col>
                          </v-row>
                          <v-row>
                              <v-col cols="12" md="6">
                                 <span>Seu Email</span>
                                 <v-text-field :rules="ruleEmailRequired" v-model="editedItem.usuarioPrincipal"></v-text-field>
                              </v-col>
                               <v-col cols="12" md="6">
                                 <span>Sua Senha</span>
                                 <v-text-field :rules="ruleRequired" type="password" v-model="editedItem.senha"></v-text-field>
                              </v-col>
                          </v-row>
                          <small style="color:red;font-weight:bold;">* - Indica campos de preenchimento obrigatório.</small>
                        </v-card-text>
                    
                     <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn color="blue darken-1" style="color:white;" :disabled="!valid1"  @click="Proximo()">Próximo ></v-btn>
                      <v-btn color="red darken-1" style="color:white;"   @click="$router.push('/')">Cancelar</v-btn>
                    </v-card-actions>
                      </v-card>
              </v-form>
                    </v-stepper-content>

                    <v-stepper-content step="2">
                      <v-card
                        class="mb-12"
                        color="white"
                        style="background-color:#ccc;"
                        height="500px"

                      >
                        <v-alert v-model="alerta" type="success">
                          <v-icon>done</v-icon> Configuração efectuada com sucesso!
                      </v-alert>
                        <v-card-title>Tipo de Negócio</v-card-title>

                        <v-card-text>
                            <v-list>
                              <template v-for="(item, index) in negocios">
                                <v-subheader
                                  v-if="item.header"
                                  :key="item.descricao"
                                  v-text="titulo"
                                ></v-subheader>

                                <v-divider
                                  v-else-if="item.divider"
                                  :key="index"
                                  :inset="item.inset"
                                ></v-divider>

                                <v-list-item
                                  v-else
                                  :key="item.descricao"
                                >

                                  <v-list-item-content>
                                    <v-list-item-title v-html="item.descricao"></v-list-item-title>
                                  </v-list-item-content>
                                  <v-list-item-action>
                                    <v-switch v-model="model[negocios.indexOf(item)]" @change="Seleciona(item)"  label="l"></v-switch>
                                  </v-list-item-action>
                                </v-list-item>
                              </template>
                            </v-list>
                        </v-card-text>
                      </v-card>

                      <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn color="blue darken-1" text  @click="e1 = e1-1">Anterior</v-btn>
                      <v-btn color="blue darken-1" style="color:white;" :disabled="itemSelecionado === null || itemSelecionado === false"  @click="Proximo2()">Próximo ></v-btn>
                    </v-card-actions>
                    </v-stepper-content>


                    <v-stepper-content step="3">
                      <v-card
                        class="mb-12"
                        color="white"
                        style="background-color:#ccc;"
                        height="500px"

                      >
                        <v-alert v-model="alerta" type="success">
                          <v-icon>done</v-icon> Configuração efectuada com sucesso!
                      </v-alert>
                        <v-card-title>Tipo de Regime</v-card-title>

                        <v-card-text>
                            <v-list>
                              <template v-for="(item, index) in tipoRegimes">
                                <v-subheader
                                  v-if="item.header"
                                  :key="item.descricao"
                                  v-text="titulo"
                                ></v-subheader>

                                <v-divider
                                  v-else-if="item.divider"
                                  :key="index"
                                  :inset="item.inset"
                                ></v-divider>

                                <v-list-item
                                  v-else
                                  :key="item.descricao"
                                >

                                  <v-list-item-content>
                                    <v-list-item-title v-html="item.descricao"></v-list-item-title>
                                  </v-list-item-content>
                                  <v-list-item-action>
                                    <v-switch v-model="modelRegime[tipoRegimes.indexOf(item)]" @change="SelecionaRegime(item)"  label="l"></v-switch>
                                  </v-list-item-action>
                                </v-list-item>
                              </template>
                            </v-list>
                        </v-card-text>
                      </v-card>

                      <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn color="blue darken-1" text  @click="e1 = e1-1">Anterior</v-btn>
                      <v-btn color="blue darken-1" style="color:white;" :disabled="itemSelecionado === null || itemSelecionado === false"  @click="Proximo2()">Próximo ></v-btn>
                    </v-card-actions>
                    </v-stepper-content>

                    <v-stepper-content step="4">
                       <v-card
                        class="mb-12"
                        color="white"
                        style="background-color:#ccc;"
                        height="500px"
                      >
                        <v-card-title>Dados Pré-definidos</v-card-title>
                    <v-form
                    ref="form2"
                    v-model="valid2"
                    lazy-validation
                    >
                        <v-card-text>
                          <v-row>
                              <v-col cols="12" md="12">
                                <span>{{caixaMesa}}</span>
                                  <v-text-field v-model="numeroCaixaMesa" :label="labelCaixaMesa" :hint="hint" ></v-text-field>
                              </v-col>
                          </v-row>
                           <v-row>
                              <v-col md="6">
                                 <span>Email da empresa*</span>
                                 <v-text-field v-model="editedItem.emailEmpresa" :rules="ruleRequired"   label="Ex: contacto@softlineangola.com" ></v-text-field>
                              </v-col>
                              <v-col md="6">
                                 <span>Website</span>
                                 <v-text-field v-model="editedItem.site"  :rules="ruleRequired"  label="Ex: www.softlineangola.com" ></v-text-field>
                              </v-col>
                          </v-row>
                           <v-row>
                              <v-col md="6">
                                 <span>Provincia*:</span>
                                 <v-text-field v-model="editedItem.endereco"  :rules="ruleRequired"  label="Provincia" ></v-text-field>
                              </v-col>
                              <v-col md="6">
                                 <span>Localidade*:</span>
                                 <v-text-field v-model="editedItem.localidade"  :rules="ruleRequired"  label="Municipio,Bairro , rua" ></v-text-field>
                              </v-col>
                          </v-row>
                        </v-card-text>
                    </v-form>
                      </v-card>

                      <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn color="blue darken-1" text  @click="e1 = e1-1">Anterior</v-btn>
                      <v-btn color="blue darken-1" style="color:white;" :disabled="itemSelecionado === null || itemSelecionado === false || !valid2"  @click="Terminar()">Terminar</v-btn>
                    </v-card-actions>
                    </v-stepper-content>
                  </v-stepper-items>
                </v-stepper>
              </template>
               <v-overlay :value="overlay">
                <v-progress-circular indeterminate size="64"></v-progress-circular>
              </v-overlay>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </v-content>
  </v-app>
</template>

<script>
import axios from '../../plugins/axios'
const numero = require('numero-por-extenso')
export default {
  data () {
    return {
      e1: 1,
      model: [],
      alerta: false,
      negocios: [],
      tipoRegimes:[],
      modelRegime:[],
      tipoRegimeSelecionado: null,
      titulo: 'Selecione o tipo de negócio',
      valid: true,
      valid1: true,
      ruleRequired: [value => !!value || 'campo obrigatorio'],
      ruleNumber: [
        value => !!value || 'campo obrigatório.',
        value => {
          const pattern = /^[0-9]*$/
          return pattern.test(value) || 'O valor deve ser numerico.'
        }
      ],
      itemIndice: -1,
      itemSelecionado: null,
      overlay: false,
      valid2: true,
      caixaMesa: '',
      labelCaixaMesa: '',
      numeroCaixaMesa: '',
      hitDesc: '',
      editedItem: {
        empresa: '',
        contribuinte: '',
        usuarioPrincipal: '',
        negocio: null,
        senha: '',
        nome: '',
        emailEmpresa: '',
        site: '',
        endereco: '',
        localidade: '',
        tipoRegime: null
      },
      caixasMesaIniciais:
      [
        { descricao: '4' },
        { descricao: '5' },
        { descricao: '6' },
        { descricao: '7' },
        { descricao: '10' }
      ],
      ruleEmailRequired: [
      //  value => !!value || 'Required.',
        value => value.length <= 50 || 'Máximo número de carácteres atigidos',
        value => !!value || 'campo obrigatório.',
        value => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          return pattern.test(value) || 'Invalid e-mail.'
        }
      ]
    }
  },

  computed: {
    hint () {
      return numero.porExtenso(this.numeroCaixaMesa) + ' ' + this.hitDesc
    }
  },

  created () {
    this.initializeNegocios()
    this.InitializeTiposRegime()
  },

  methods: {
    Seleciona (item) {
      let indice = this.negocios.indexOf(item)
      this.DisabilitaOutros(indice)
      this.itemIndice = indice
      this.itemSelecionado = this.model[indice]
      this.editedItem.negocio = item
    },

    /**
     * 1-Geral
     * 2-Simplificado
     * 3-Exclusão
     */

    SelecionaRegime (item){
      let indice = this.tipoRegimes.indexOf(item)
      this.DisabilitaOutrosRegime(indice)
      this.itemIndice = indice
      this.itemSelecionado = this.modelRegime[indice]
      this.editedItem.tipoRegime = item
      console.log(this.editedItem.tipoRegime);
    },
    DisabilitaOutros (indice) {
      for (let index = 0; index < this.negocios.length; index++) {
        if (index !== indice) { this.model[index] = false }
      }
    },
    DisabilitaOutrosRegime (indice) {
      for (let index = 0; index < this.tipoRegimes.length; index++) {
        if (index !== indice) { this.modelRegime[index] = false }
      }
    },
     async InitializeTiposRegime () {
      this.overlay = true
      try {
        //   let  payload =""
        this.tipoRegimes = await axios
          .get('/tiposRegime')
          .then(res => res.data)
        this.overlay = false
      } catch (error) {
        this.overlay = false
        this.text = error
        this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 })
      }
    },
    async initializeNegocios () {
      this.overlay = true
      try {
        //   let  payload =""
        this.negocios = await axios
          .get('/negociosListagem')
          .then(res => res.data)
        let obj = {
          header: 'Selecione o tipo de negócio'
        }
        this.negocios.unshift(obj)
        this.overlay = false
      } catch (error) {
        this.overlay = false
        this.text = error
        this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 })
      }
    },
    Proximo () {
      if (this.$refs.form1.validate()) {
        this.e1++
      }
    },
    Proximo2 () {
      if (this.editedItem.negocio.descricao === 'Restaurante' || this.editedItem.negocio.descricao === 'Café') {
        this.caixaMesa = 'Número de Mesas'
        this.labelCaixaMesa = 'Insira o número de Mesas Iniciais'
        this.hitDesc = 'Mesas'
      } else {
        this.caixaMesa = 'Número de Caixas'
        this.labelCaixaMesa = 'Insira o número de Caixas Iniciais'
        this.hitDesc = 'Caixas'
      }

      this.e1++
    },
    async Terminar () {
      if (this.$refs.form2.validate()) {
        this.overlay = true
        let params = {
          Empresa: this.editedItem.empresa,
          contribuinte: this.editedItem.contribuinte,
          usuario: this.editedItem.usuarioPrincipal,
          senha: this.editedItem.senha,
          nome: this.editedItem.nome,
          negocio: this.editedItem.negocio.descricao,
          pkNegocio: this.editedItem.negocio.pkNegocios,
          numeroMesasCaixas: parseInt(this.numeroCaixaMesa),
          MesaCaixa: (this.hitDesc === 'Mesas') ? 1 : 2,
          site: this.editedItem.site,
          email: this.editedItem.emailEmpresa,
          endereco: this.editedItem.endereco,
          localidade: this.editedItem.localidade,
          tipoRegime: this.editedItem.tipoRegime
        }
        try {
        //   let  payload =""
          let result = await axios
            .post('/configEmpresaOrUpdate', params)
            .then(res => res.data)

          if (result.affectedRows >= 1) {
            setTimeout(() => {
              this.overlay = false
              this.alerta = true
              setTimeout(() => {
                this.alerta = false
                this.$router.push('/')
              }, 2000)
            }, 2000)
          }
        } catch (error) {
          this.text = error
          this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 })
        }
        this.overlay = true
      }
    }

  }
}
</script>
<style scoped>
   #inspire{
      background-color: antiquewhite;
      background-image: url( '/img/logo.jpg ')
   }
</style>